export interface ICreditCardDetails {
    /**
     * CardholderName
     */
    readonly cardholderName: string;
    /**
     * CardNumber
     */
    readonly cardNumber: string;
    /**
     * ExpiryMonth
     */
    readonly expiryMonth: number;
    /**
     * ExpiryYear
     */
    readonly expiryYear: number;
    /**
     * IsReusable
     */
    readonly isReusable?: boolean;
    /**
     * Label
     */
    readonly label?: string;
    /**
     * SaveCard
     */
    readonly saveCard: boolean;
    /**
     * SecurityCode
     */
    readonly securityCode: string;
}
